import axios from 'axios'

import { NotificationChannel } from '@tribeplatform/gql-client/types'
import { useDomain } from '@tribeplatform/react-components/common'
import { useRouter } from '@tribeplatform/react-sdk'
import {
  useAuthToken,
  useUpdateMemberNetworkNotificationSettings,
} from '@tribeplatform/react-sdk/hooks'

export const useLogout = () => {
  const { redirect } = useRouter()
  const { subfolder } = useDomain()
  const { mutateAsync: updateMemberNetworkNotificationSettings } =
    useUpdateMemberNetworkNotificationSettings()
  const {
    data: { network, accessToken },
  } = useAuthToken()

  const logout = async () => {
    try {
      await Promise.allSettled([
        axios.get(`${subfolder || ''}/api/auth/logout`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }),
        updateMemberNetworkNotificationSettings({
          channel: NotificationChannel.DESKTOP,
          input: {
            enabled: false,
          },
        }),
      ])
    } catch (e) {
      console.warn('Could not logout the user')
    }
    redirect(network.activeSso?.logoutUrl || '/auth/login?auto_login=false')
  }

  return {
    logout,
  }
}
